import { addItemToBasket, removeItemFromBasket, selectBasketCheckPriceItem, selectBasketDeliveries, selectBasketItem, selectBasketList, selectBasketToPay, updateBasketItem, updateDelivery } from 'containers/OrderDetails/basketSlice'
import useOpeningMethodData from '../hooks/useOpeningMethodData'
import DeliveryPopup from 'components/popups/DeliveryPopup'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import placeholder from 'assets/img/placeholder.png'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { displayPrice } from 'utils/string'
import Popup from 'components/popups/Popup'
import Loading from 'components/Loading'
import Error from 'components/Error'
import { useState } from 'react'

const RfidPopup = ({ method, addToGate = false, cancelAction }) => {
  const { id } = useParams()
  const list = useSelector(selectBasketList)
  const toPay = useSelector(selectBasketToPay)
  const selectedRefids = getAllRfidsFromTheBasket(list)
  const deliveries = useSelector(selectBasketDeliveries)
  const [productDetails, setProductDetails] = useState(null)
  const recentlySelectedDeliveries = useSelector(selectBasketDeliveries)
  const selectedBasketItem = useSelector(state => selectBasketItem(state, id))
  const { placeName, placeAddress } = useSelector(state => selectBasketCheckPriceItem(state, id))
  const { isLoading, padlockInfo } = useOpeningMethodData(method.id, setProductDetails)
  const [isShopVisible, setShopVisible] = useState(selectedRefids.length === 0)

  const { t } = useTranslation('delivery')
  const { goBack } = useHistory()
  const dispatch = useDispatch()

  const generateRelatedElement = () => {
    return addToGate
      ? { object: 'Place', name: placeName, id: selectedBasketItem.placeId }
      : { object: selectedBasketItem.object || 'Warehouse', id: selectedBasketItem.id, name: selectedBasketItem.name, cartId: selectedBasketItem.identifier }
  }

  if (isShopVisible && productDetails) {
    return (
      <DeliveryPopup
        placeAddress={placeAddress}
        popupName={t('proximityAccess')}
        delivery={productDetails?.delivery}
        additionalText={t('openGatesAndStorages')}
        productName={productDetails?.name || method?.name}
        price={productDetails?.grossPrice || method?.grossPrice}
        deliveryMethods={productDetails?.deliveryMethods || method.deliveryMethods}
        recentlySelectedDeliveries={recentlySelectedDeliveries}
        setRecentlySelectedDeliveries={(getState) => {
          const state = typeof getState === 'function' ? getState(recentlySelectedDeliveries) : getState
          dispatch(updateDelivery(state))
        }}
        cancelAction={() => {
          setProductDetails(null)
        }}
        callback={values => {
          // update
          if (productDetails?.cartId) {
            dispatch(updateBasketItem({ identifier: productDetails.cartId, values }))

            // add new
          } else {
            const value = {
              id: method.id,
              placeId: selectedBasketItem.placeId,
              name: productDetails.name || method.name,
              openingMethodKey: method.openingMethodKey,
              depositAmount: method.depositAmount,
              related: [generateRelatedElement()],
              object: productDetails.object,
              objectId: productDetails.id,
              ...values
            }
            dispatch(addItemToBasket({ type: 'rentAddon', ...value }))
          }
          setProductDetails(null)
          setShopVisible(false)
        }}
      />
    )
  }

  return (
    <Popup close={cancelAction || goBack} darkBg={true}>
      {isShopVisible
        ? <>
          <div className='popup__title'>
            <div>{t('proximityAccess')}</div>
            <i
              className='icon icon--back s32'
              onClick={() => {
                setShopVisible(false)
              }} />
          </div>
          <div className='popup__rfid'>
            <div className='popup__rfid__info'>{t('openGatesAndStorages')}</div>
            <div className='popup__rfid__items'>
              <h2>{t('chooseCardType')}</h2>
              {isLoading
                ? <Loading />
                : padlockInfo
                  ? padlockInfo.map((data) => {
                    const { id, name, grossPrice, image_url, depositAmount } = data
                    return <div
                      key={id}
                      className='popup__rfid__item --smallPadding'
                      onClick={() => {
                        setProductDetails(data)
                      }} >
                      <div className='popup__rfid__item__image'>
                        <img
                          alt={name}
                          src={image_url || placeholder}
                        />
                      </div>
                      <div className='popup__rfid__item__content'>
                        <h3>{name}</h3>
                        {depositAmount && <div>{t('deposit')}: {displayPrice(depositAmount)}</div>}
                        {grossPrice && <div>{t('price')}: {displayPrice(grossPrice)}</div>}
                      </div>
                      <div className='popup__padlock__item__actions'>
                        <div className='checkCircle'>
                          <i className='icon icon--check' />
                        </div>
                      </div>
                    </div>
                  })
                  : <Error staticPos />}
            </div>
          </div>
        </> : <>
          <div className='popup__title'>
            <div>{t('proximityAccess')}</div>
          </div>
          <div className='popup__rfid'>
            <div className='popup__rfid__items'>
              <h2>{t('chooseOwnedCard')}</h2>
              {selectedRefids.map(({ identifier, objectId, name, related, deliveryId }) => {
                const isSelected = related.some(r => addToGate ? r.id === selectedBasketItem.placeId : r.cartId === selectedBasketItem.identifier)
                const delivery = (deliveryId && deliveries) ? deliveries.find(d => d.id === deliveryId) : undefined
                const toPayData = (toPay && identifier) ? toPay[identifier] : undefined
                return <div
                  key={identifier}
                  className={`popup__rfid__item${isSelected ? ' checked' : ''}`}
                  onClick={() => {
                    dispatch(updateBasketItem({
                      identifier,
                      values: {
                        related: isSelected
                          ? related?.filter(r => addToGate ? r.id !== selectedBasketItem.placeId : r.cartId !== selectedBasketItem.identifier)
                          : [...(related || []), generateRelatedElement()]
                      }
                    }))
                  }}>
                  <div className='popup__rfid__item__marker'>{t('ordered')}</div>
                  <div className='popup__rfid__item__content'>
                    <h3>{name}{(toPayData?.to_pay?.depositAmount && toPayData?.to_pay?.price_sum) ? ` (${displayPrice(Number(toPayData.to_pay.price_sum) - Number(toPayData.to_pay.depositAmount))})` : ''}</h3>
                    {toPayData?.to_pay?.depositAmount && <div>{t('deposit')}: {displayPrice(toPayData?.to_pay?.depositAmount)}</div>}
                    {toPayData?.to_pay?.price_sum && <div>{t('amountToPay')}: {displayPrice(toPayData?.to_pay?.price_sum)}</div>}
                    {delivery?.type && <div>{t('delivery')}: {t(delivery?.type)}</div>}
                  </div>
                  <div className='popup__rfid__item__actions'>
                    <i
                      className='icon icon--trash'
                      onClick={e => {
                        e.stopPropagation()
                        dispatch(removeItemFromBasket({ removeIdentifiers: [identifier] }))
                      }} />
                    <i
                      className='icon icon--rename'
                      onClick={e => {
                        e.stopPropagation()
                        const selectedRfid = padlockInfo?.find(p => p.id === objectId)
                        if (selectedRfid) {
                          setShopVisible(true)
                          setProductDetails({
                            ...selectedRfid,
                            cartId: identifier,
                            delivery
                          })
                        }
                      }} />
                    <div className='checkCircle'>
                      <i className='icon icon--check'></i>
                    </div>
                  </div>
                </div>
              })}
            </div>

            <button
              className='button --coupon'
              onClick={() => setShopVisible(true)}>+ {t('buyRfid')}</button>
          </div>
        </>}

      <ArrowBtn
        enlarged
        text={t('ready')}
        showArrow={false}
        action={goBack}
      />
    </Popup>
  )
}

const getAllRfidsFromTheBasket = (basketList) => {
  const list = []
  for (const item of basketList) {
    if (item?.openingMethodKey === 'rfid') {
      list.push(item)
    }
  }
  return list
}

export default RfidPopup